export const isDarkColor = (color: any) => {
  // Variables for red, green, blue values
  let red;
  let green;
  let blue;
  let hsp;

  // If hex --> Convert it to RGB: http://gist.github.com/983661
  color = +("0x" + color.slice(1).replace(color.length < 5 && /./g, "$&$&"));

  red = color >> 16;
  green = (color >> 8) & 255;
  blue = color & 255;

  // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
  hsp = Math.sqrt(0.299 * (red * red) + 0.587 * (green * green) + 0.114 * (blue * blue));

  // Using the HSP value, determine whether the color is light or dark
  if (hsp > 150) {
    return false;
  } else {
    return true;
  }
};
